import $ from 'jquery';

export const setMenuToggle = () => {
    window.$.AdminBSB.leftSideBar.activate();
    //When page load
    $('.menu .list li a').removeClass('toggled');
    $.each($('.menu .list li.active'), function(i, val) {
        var $activeAnchors = $(val).find('a:eq(0)');
        $activeAnchors.addClass('toggled');
        $activeAnchors.next().show();
    });
}



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/sidebar/menu/MenuToggle.js